import { render, staticRenderFns } from "./Security.htm?vue&type=template&id=83550236&scoped=true&"
import script from "./Security.js?vue&type=script&lang=js&"
export * from "./Security.js?vue&type=script&lang=js&"
import style0 from "./Security.scss?vue&type=style&index=0&id=83550236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83550236",
  null
  
)

export default component.exports